import { GeneralSearchInput } from "../../../param/generalSearchInput";
import { ListDefinition } from "../../../param/listDefinitionType";
import { Result } from "../generalSearchResult";
import { candidateCharactersFilter } from "./candidateCharactersFilter";
import { conditionalTransform } from "./conditionTransform";
import { dictionaryMatchFilter } from "./dictionaryMatchFilter";
import { fishBoneFilter } from "./fishBoneFilter";
import { identicalTraceFilter } from "./identicalTraceFilter";
import { keyValueMatch } from "./keyValueMatch";
import { lengthFilter } from "./lengthFilter";
import { parallelTransform } from "./parallelTransform";
import { regexFilter } from "./regexFilter";
import { regexMatchCompareFilter } from "./regexMatchCompareFilter";
import { regexReplaceSearch } from "./regexReplaceSearch";
import { traceGrouping } from "./traceGrouping";

export const generalSearchFuncTable: {
  [key: string]: (args: {
    query: any;
    input: GeneralSearchInput;
    words: string[];
    listDefinitionsTable: Record<string, ListDefinition>;
    result: Result;
    workerContext: any;
  }) => Promise<Result>;
} = {
  regex: regexFilter,
  dictionaryMatch: dictionaryMatchFilter,
  keyValueMatch,
  identicalTrace: identicalTraceFilter,
  length: lengthFilter,
  candidateCharacters: candidateCharactersFilter,
  regexMatchCompare: regexMatchCompareFilter,
  regexReplace: regexReplaceSearch,
  regexReplaceSearch,
  parallelTransform,
  conditionalTransform,
  fishBone: fishBoneFilter,
  traceGrouping: traceGrouping
};
